/**
 * Formats a number to a fixed number of decimal places.
 *
 * @param number - The number to format.
 * @param places - The number of decimal places to format to.
 * @returns The formatted number.
 */
export function formatFloat(number: number, places: number) {
  const multi = Math.pow(10, places)
  return parseInt((number * multi).toString(), 10) / multi
}
